import { createGlobalStyle } from 'styled-components';

export const ClientPolicyholdersModalStyles = createGlobalStyle`
  .client-policyholders-modal {
    max-width: 460px;

    .modal-content {
      border: 0;
      border-radius: 4px;
      overflow: hidden;
      min-height: 284px;
    }

    .modal-header {
      align-items: center;
      height: 57px;
      padding: 0 16px;
      border: 0;
      border-radius: 4px 4px 0 0;
      background-color: #21354a;
    }

    .modal-title {
      font-size: 16px;
      font-weight: 700;
      line-height: normal;
      color: #fff;
    }

    .close-button {
      display: flex;
      align-items: center;
      padding: 0;
      border: 0;
      background: transparent;
      color: #fff;

      .material-icons {
        font-size: 24px;
      }
    }

    .modal-body {
      padding: 24px 16px;
      font-size: 16px;
      line-height: 1.2;
      letter-spacing: -0.32px;
      color: #000;
    }

    .policyholder-item + .policyholder-item {
      margin-top: 24px;
    }
  }
`;
